// src/services/inventoryIntelApi.js
// --- UPDATE (Inventory Enterprise v1) — NEW FILE -----------------------------------------
// Client for /api/v1/inventory-intel (AI/ML intelligence, stock movements, part ↔ asset links,
// CSV exports) and /api/v1/fleet (government vehicles). Errors carry the server message + status.
// --- END UPDATE ---------------------------------------------------------------------------
import { config } from '../config';
import { getAuthToken } from '../utils/auth';

const headers = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${getAuthToken() || ''}` });

async function call(path, { method = 'GET', body, signal } = {}) {
    const res = await fetch(`${config.apiUrl}${path}`, { method, signal, headers: headers(), body: body === undefined ? undefined : JSON.stringify(body) });
    let json = {};
    try { json = await res.json(); } catch (_) { json = {}; }
    if (!res.ok) { const e = new Error(json.message || `Request failed (${res.status})`); e.status = res.status; throw e; }
    return json.data !== undefined ? json.data : json;
}
const qs = (o = {}) => {
    const s = Object.entries(o).filter(([, v]) => v !== undefined && v !== null && v !== '' && v !== 'all').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
    return s ? `?${s}` : '';
};

/** Downloads a CSV export with the signed-in token (a plain link would not send it). */
async function download(kind) {
    const res = await fetch(`${config.apiUrl}/inventory-intel/export/${encodeURIComponent(kind)}`, { headers: headers() });
    if (!res.ok) { let m = `Export failed (${res.status})`; try { m = (await res.json()).message || m; } catch (_) { /* */ } throw new Error(m); }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `flowsense-${kind}-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export const inventoryIntelApi = {
    overview: ({ refresh = false, signal } = {}) => call(`/inventory-intel/overview${refresh ? '?refresh=1' : ''}`, { signal }),
    lookups: () => call('/inventory-intel/lookups'),
    insight: (itemId) => call(`/inventory-intel/items/${encodeURIComponent(itemId)}/insight`),
    movements: (itemId, limit = 50) => call(`/inventory-intel/items/${encodeURIComponent(itemId)}/movements${qs({ limit })}`),
    recordMovement: (itemId, body) => call(`/inventory-intel/items/${encodeURIComponent(itemId)}/movements`, { method: 'POST', body }),
    links: (filters) => call(`/inventory-intel/links${qs(filters)}`),
    createLink: (body) => call('/inventory-intel/links', { method: 'POST', body }),
    deleteLink: (id) => call(`/inventory-intel/links/${encodeURIComponent(id)}`, { method: 'DELETE' }),
    partsFor: (type, id) => call(`/inventory-intel/parts-for/${encodeURIComponent(type)}/${encodeURIComponent(id)}`),
    download,
};

export const fleetApi = {
    meta: () => call('/fleet/meta'),
    list: (filters) => call(`/fleet${qs(filters)}`),
    get: (id) => call(`/fleet/${encodeURIComponent(id)}`),
    create: (body) => call('/fleet', { method: 'POST', body }),
    update: (id, body) => call(`/fleet/${encodeURIComponent(id)}`, { method: 'PUT', body }),
    remove: (id, permanent = false) => call(`/fleet/${encodeURIComponent(id)}${permanent ? '?permanent=true' : ''}`, { method: 'DELETE' }),
    addEvent: (id, body) => call(`/fleet/${encodeURIComponent(id)}/events`, { method: 'POST', body }),
};

export default inventoryIntelApi;
